<script lang="ts">
    import { onMount } from "svelte";

    import { fade } from "svelte/transition";
    import { StorageKeys } from "./enums/localStorageKeys";
    import { selectedLanguageCode } from "./store";

    interface Language {
        flagSvg: string;
        languageCode: string;
        name: string;
    }

    let showLanguageSelection = false;

    let languages: Array<Language> = [
        { flagSvg: "de.svg", languageCode: "de", name: "German" },
        { flagSvg: "fr.svg", languageCode: "fr", name: "French" },
        { flagSvg: "gb.svg", languageCode: "en", name: "English" },
        { flagSvg: "it.svg", languageCode: "it", name: "Italien" },
        { flagSvg: "nl.svg", languageCode: "nl", name: "Dutch" },
    ];

    let selectedLanguage: Language = languages[0];

    onMount(() => {
        let storedLanguageString = localStorage.getItem(
            StorageKeys.SelectedLanguage
        );
        if (!storedLanguageString) return;
        selectedLanguage = JSON.parse(storedLanguageString);
        selectedLanguageCode.set(selectedLanguage.languageCode);
    });

    function onLanguageClicked(language: Language) {
        localStorage.setItem(
            StorageKeys.SelectedLanguage,
            JSON.stringify(language)
        );
        selectedLanguageCode.set(language.languageCode);
        showLanguageSelection = false;
        selectedLanguage = language;
    }
</script>

<div>
    <button
        on:click={() => (showLanguageSelection = !showLanguageSelection)}
        id="dropdownDividerButton"
        data-dropdown-toggle="dropdownDivider"
        class="flex content-between items-center w-full py-4"
        type="button"
    >
        <img
            class="max-h-4 w-4"
            alt="Language selection"
            src={"assets/flags/" + selectedLanguage.flagSvg}
        />
        <svg
            class="ml-2 w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            ><path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M19 9l-7 7-7-7"
            /></svg
        ></button
    >

    <!-- Dropdown menu -->
    {#if showLanguageSelection}
        <div
            transition:fade
            id="dropdownDivider"
            class="absolute right-4 z-10 w-44 text-base list-none bg-white rounded divide-y divide-gray-100 shadow dark:bg-gray-700 dark:divide-gray-600"
        >
            <ul class="py-1" aria-labelledby="dropdownDividerButton">
                {#each languages as language}
                    <li
                        class={(selectedLanguage === language
                            ? "text-gray-300 font-bold"
                            : " ") + " px-2 "}
                    >
                        <button
                            class="languageBtn hover:bg-blue-500"
                            on:click={() => onLanguageClicked(language)}
                        >
                            <img
                                class="max-h-4"
                                alt="Language selection"
                                src={"assets/flags/" + language.flagSvg}
                            />
                            <span class="max-h-6">{language.name}</span>
                        </button>
                    </li>
                {/each}
            </ul>
        </div>
    {/if}
</div>

<style>
    .languageBtn {
        @apply rounded-sm;
        @apply flex;
        @apply h-8;
        @apply w-full;
        @apply items-center;
        @apply gap-2;
        @apply px-2;
    }
</style>
